import type { HotelFilter } from "@/lib/redux/features/hotel/type"

export type HotelFilterMap = { [category: string]: HotelFilter }

const isFilterMap = (payload: unknown): payload is HotelFilterMap => {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return false
  return Object.values(payload).some((item) => item && typeof item === "object" && "category" in item)
}

export const normalizeHotelFilterOptions = (payload: unknown): HotelFilterMap => {
  if (isFilterMap(payload)) return payload

  if (!Array.isArray(payload) || payload.length === 0) return {}

  const data: HotelFilterMap = {}

  for (let i = 0; i < payload.length; i++) {
    const filter = payload[i]
    if (!filter?.category) continue

    if (filter.category === "BENEFIT") {
      data[filter.category] = {
        ...filter,
        options: (filter?.options || [])
          .sort(({ key: key1 }: any, { key: key2 }: any) => key1 - key2)
          .filter(({ key, isPopular }: any) => key <= 10 || isPopular === 1),
      }
    } else {
      data[filter.category] = filter
    }
  }

  return data
}
